/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */

const state = {
  permits: {},
  errors: {},
  kioskId: null,
  filters: {
    startDate: null,
    endDate: null,
    vehicle_nr: '',
    id_code: '',
    state: 'all',
    permit_status: 'active',
  },
  isLoading: false,
};

const getters = {
  permits: state => state.permits,
  errors: state => state.errors,
  kioskId: state => state.kioskId,
  filters: state => state.filters,
  isLoading: state => state.isLoading,
};

const actions = {
  storeData({ commit }, payload) {
    commit('storeData', payload);
  },
  setToList({ commit }, payload) {
    commit('setToList', payload);
  },
  clear({ commit }) {
    commit('clearState');
  },
  setFilterDates({ commit }, payload) {
    commit('setFilterDates', payload);
  },
  setLoading({ commit }, payload) {
    commit('setLoading', payload);
  }
}

const mutations = {
  ['storeData'](state, data) {
    const dataName = data.varName
    state.filters[dataName] = data.value
  },
  ['setToList'](state, data) {
    state.permits.push(data)
  },
  ['clearState'](state) {
    state.errors = []
    state.permits = []
  },
  ['setFilterDates'](state, data) {
    state.filters.startDate = data.startDate
    state.filters.endDate = data.endDate
  },
  ['setLoading'](state, data) {
    state.isLoading = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/kiosks/permits.js